import { QueryClient } from "@tanstack/react-query";

/**
 * Default QueryClient configuration
 * Browser-safe utilities
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute default
      refetchOnWindowFocus: false,
    },
  },
});
